export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_09.9fd50243.jpg";